<div class="notification-card" [class]="severity">
  <ng-content></ng-content>
</div>
